// api.ts - Updated API service with better error handling
import { RegisterRequest, RegisterResponse, VerifyOtpRequest, VerifyOtpResponse, 
         VerifyRegisterResponse, RegisterUserRequest, RegisterUserResponse, PhoneLoginRequestDTO } from '../types/api';
import { fetchWithErrorHandling } from '../utils/errorHandler';

const API_PATH = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = `${API_PATH}/api/v1`;

// Helper function to get basic headers
const getHeaders = () => ({
  'Accept': 'application/json',
  'Content-Type': 'application/json',
});

export const api = {
  async register(data: RegisterRequest): Promise<RegisterResponse> {
    return fetchWithErrorHandling(`${API_BASE_URL}/auth/register-user`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
  },

  async verifyOtp(data: VerifyOtpRequest): Promise<VerifyOtpResponse> {
    return fetchWithErrorHandling(`${API_BASE_URL}/auth/verify-otp`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
  },

  async verifyRegister(data: VerifyOtpRequest): Promise<VerifyRegisterResponse> {
    try {
      const response = await fetchWithErrorHandling(`${API_BASE_URL}/auth/verify-register`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(data),
      });
      
      // Handle the special case where the response is just the OTP text
      if (typeof response === 'string' && !response.startsWith('{')) {
        return { success: true, message: 'OTP sent successfully', otp: response };
      }
      
      return response;
    } catch (error) {
      // Re-throw the error so it's caught by the component
      throw error;
    }
  },

  async registerUser(data: RegisterUserRequest): Promise<RegisterUserResponse> {
    return fetchWithErrorHandling(`${API_BASE_URL}/auth/register-user`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
  },

  async loginWithPhoneAndPass(phoneRequest: PhoneLoginRequestDTO): Promise<RegisterUserResponse> {
    return fetchWithErrorHandling(`${API_BASE_URL}/auth/password-login`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(phoneRequest),
    });
  }
};